// extracted by mini-css-extract-plugin
export var cancelButton = "_pw-5";
export var content = "_pw-3";
export var createButton = "_pw-6";
export var drawerContainer = "_pw-0";
export var footer = "_pw-2";
export var header = "_pw-1";
export var orderFormColumn = "_pw-4";